import React, {Component} from 'react';
import NavBar from "./NavBar";
import Footer from "./Footer";
import NexusDeviceLight from "./NexusDeviceLight";
import NexusDeviceDark from "./NexusDeviceDark";

import screenRigChecksList from '../images/screenshot_rigcheck_list.png';
import screenRigChecksCreate from '../images/screenshot_rigcheck_create.png';
import screenInventory from '../images/screenshot_inventory.png';
import screenChecklist from '../images/screenshot_checklist.png';
import screenBatches from '../images/screenshot_batches.png';
import screenChecklists from '../images/screenshot_checklists.png';
import screenStations from '../images/screenshot_stations.png';
import screenUsers from '../images/screenshot_users.png';
import screenAmbulances from '../images/screenshot_ambulances.png';

class Features extends Component {

    componentDidMount() {
        document.title = "RigChecks - features";
    }

    render() {
        return (
            <div>
                <NavBar/>

                <div className="pt-5 pb-4"/>

                <div className="d-md-flex flex-md-equal w-100 my-md-3 pl-md-3">
                    <div
                        className="bg-dark mr-md-3 pt-3 px-3 pt-md-5 px-md-5 text-center text-white overflow-hidden box-shadow device-card">
                        <div className="my-3 py-3 ">
                            <h2 className="display-5">Every RigCheck in one location</h2>
                            <p className="lead">View a list of RigChecks and see the times they were done along with the
                                user who completed them.</p>
                        </div>
                        <div className="mx-auto"
                             style={{width: "80%", height: "400px", borderRadius: "21px 21px 0 0"}}>
                            <NexusDeviceLight imageSrc={screenRigChecksList}/>
                        </div>
                    </div>
                    <div
                        className="bg-light mr-md-3 pt-3 px-3 pt-md-5 px-md-5 text-center overflow-hidden box-shadow device-card">
                        <div className="my-3 py-3">
                            <h2 className="display-5">Simple, straight forward Rigchecks</h2>
                            <p className="lead">Doing a rigcheck is as easy as swiping left. Add numbers to keep track
                                of how many items the truck has and more!</p>
                        </div>
                        <div className="mx-auto"
                             style={{width: "80%", height: "400px"}}>
                            <NexusDeviceDark imageSrc={screenRigChecksCreate}/>
                        </div>
                    </div>
                </div>
                <div className="d-md-flex flex-md-equal w-100 my-md-3 pl-md-3">
                    <div
                        className="bg-light mr-md-3 pt-3 px-3 pt-md-5 px-md-5 text-center overflow-hidden box-shadow device-card">
                        <div className="my-3 py-3">
                            <h2 className="display-5">Customize checklists</h2>
                            <p className="lead">With customizable checklists, you can add and remove compartments and
                                items.</p>
                        </div>
                        <div className="mx-auto"
                             style={{width: "80%", height: "400px", borderRadius: "21px 21px 0 0"}}>
                            <NexusDeviceDark imageSrc={screenChecklist}/>
                        </div>
                    </div>
                    <div
                        className="bg-primary mr-md-3 pt-3 px-3 pt-md-5 px-md-5 text-center text-white overflow-hidden box-shadow device-card">
                        <div className="my-3 py-3">
                            <h2 className="display-5">Manage inventory</h2>
                            <p className="lead">Manage inventory and keep track of all the items your crew uses. You can
                                even organize items by category.</p>
                        </div>
                        <div className="mx-auto"
                             style={{width: "80%", height: "400px", borderRadius: "21px 21px 0 0"}}>
                            <NexusDeviceLight imageSrc={screenInventory}/>
                        </div>
                    </div>
                </div>
                <div className="d-md-flex flex-md-equal w-100 my-md-3 pl-md-3">
                    <div
                        className="bg-dark mr-md-3 pt-3 px-3 pt-md-5 px-md-5 text-center text-white overflow-hidden box-shadow device-card">
                        <div className="my-3 py-3 ">
                            <h2 className="display-5">Add Batches of items</h2>
                            <p className="lead">Add batches for medication and keep track of lots and expiration
                                date</p>
                        </div>
                        <div className="mx-auto"
                             style={{width: "80%", height: "400px", borderRadius: "21px 21px 0 0"}}>
                            <NexusDeviceLight imageSrc={screenBatches}/>
                        </div>
                    </div>
                    <div
                        className="bg-light mr-md-3 pt-3 px-3 pt-md-5 px-md-5 text-center overflow-hidden box-shadow device-card">
                        <div className="my-3 py-3">
                            <h2 className="display-5">Create Checklists for anything</h2>
                            <p className="lead">Make a checklist for every ambulance your crew owns and operates</p>
                        </div>
                        <div className="mx-auto"
                             style={{width: "80%", height: "400px"}}>
                            <NexusDeviceDark imageSrc={screenChecklists}/>
                        </div>
                    </div>
                </div>
                <div className="d-md-flex flex-md-equal w-100 my-md-3 pl-md-3">
                    <div
                        className="bg-light mr-md-3 pt-3 px-3 pt-md-5 px-md-5 text-center overflow-hidden box-shadow device-card">
                        <div className="my-3 py-3">
                            <h2 className="display-5">Scale your stations</h2>
                            <p className="lead">Keep track of all locations weather they’re active or inactive</p>
                        </div>
                        <div className="mx-auto"
                             style={{width: "80%", height: "400px", borderRadius: "21px 21px 0 0"}}>
                            <NexusDeviceDark imageSrc={screenStations}/>
                        </div>
                    </div>
                    <div
                        className="bg-primary mr-md-3 pt-3 px-3 pt-md-5 px-md-5 text-center text-white overflow-hidden box-shadow device-card">
                        <div className="my-3 py-3">
                            <h2 className="display-5">The whole crew in one spot</h2>
                            <p className="lead">Add everyone in your crew and add different types of users with
                                different roles.</p>
                        </div>
                        <div className="mx-auto"
                             style={{width: "80%", height: "400px", borderRadius: "21px 21px 0 0"}}>
                            <NexusDeviceLight imageSrc={screenUsers}/>
                        </div>
                    </div>
                </div>

                <Footer/>
            </div>
        )
    }

}

export default Features;




// WEBPACK FOOTER //
// ./src/component/Features.js